import React from "react";
import { __ } from "@wordpress/i18n";
import { StarIcon, BusinessIcon, CloudIcon } from "../../icons";

const HIGHLIGHTS = [
  {
    title: __(
      "Trusted by 60,000+ businesses worldwide",
      "plugin-cross-sell-textdomain"
    ),
    icon: BusinessIcon,
  },
  {
    title: __("67,233,282 plugin downloads", "plugin-cross-sell-textdomain"),
    icon: CloudIcon,
  },
  {
    title: __("7,260+ 5 star reviews", "plugin-cross-sell-textdomain"),
    icon: StarIcon,
  },
];
const Highlights = () => {
  return (
    <div className="cross-sell-wrapper">
      {HIGHLIGHTS.length > 0 && (
        <div className="cross-sell-highlights">
          {HIGHLIGHTS.map((highlight, index) => (
            <div className="cross-sell-highlight" key={index}>
              <div className="cross-sell-highlight__icon">
                <highlight.icon />
              </div>
              <div className="cross-sell-highlight__title">
                {highlight.title}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { Highlights };
